import React from "react";
import { Link } from "react-router-dom";
import './hero.css';

function Hero() {

    const downloadBrochure = () => {
        fetch('https://ik.imagekit.io/nvo8yi18o/VETOMAC/VETOMAC_2023_brochure_B053v5TYo.pdf?updatedAt=1679952982693').then(response => {
            response.blob().then(blob => {
                const fileURL = window.URL.createObjectURL(blob);
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = 'VETOMAC 2023 Brochure.pdf';
                alink.click();
            })
        })
    }

    return (
        <div className="hero">
            <div style={{width: '50%'}}>
                <h2 className="conf">18ᵗʰ International Conference on Vibration Engineering & Technology Of Machinery</h2>
                <h1 className="confName">VETOMAC 2023</h1>
                <h4 className="confDate">December 18th - 20th, 2023</h4>
                <h4 className="confLoc">Indian Institute of Technology, Roorkee</h4>
                <div className="heroButtons">
                    <Link to="/registration" className="register">Register</Link>
                    <a onClick={downloadBrochure} className="download">Download Brochure</a>
                </div>
                <div style={{paddingTop: '1vmax', display: 'flex', alignItems: 'left'}}>
                <a href="https://docs.google.com/spreadsheets/d/1fQgLqXppNpjNATbMjSdC4CqcwzCOQOt_uIsy5ffgieI/edit?usp=sharing" target="_blank" style={{all: 'unset'}}>
                    <button className='submitBtn' type="submit">Fill accomodation preference here</button>
                </a>
                </div>
            </div>
            <div>
                <img style={{width: '100%'}} src="https://ik.imagekit.io/nvo8yi18o/VETOMAC/Home/mainbldg_SKVolv6lL.svg?updatedAt=1679935049350" />
            </div>
        </div>
    )
}

export default Hero;